package ir.yusefpasha.models

import ir.yusefpasha.util.Res

enum class Service(
    val icon: String,
    val title: String,
    val description: String
) {
    Android(
        icon = Res.Icon.ANDROID,
        title = "Android Developer",
        description = "More than three years of Android programming experience and doing various projects for this platform along with the development of several corporate and personal projects..."
    ),
    Web(
        icon = Res.Icon.WEB,
        title = "Web Developer",
        description = "Not-Much Experience in Personal and Small Projects Using Interesting Kobweb/Kvision Framework and also Determined to Learn more about that..."
    ),
    Backend(
        icon = Res.Icon.BACKEND,
        title = "Backend Developer",
        description = "Not-Much Experience in Personal and Small Projects Using Interesting and Lovely KTOR Framework and also Determined to Learn more about that..."
    ),
    Windows(
        icon = Res.Icon.WINDOWS,
        title = "Windows Developer",
        description = "Not-Much Experience in Personal and Small Projects Using Interesting and Lovely Kotlin KMP (Desktop,Mac,Linux) and also Determined to Learn more about that..."
    ),
    KMP(
        icon = Res.Icon.KMP,
        title = "Multi-Platform",
        description = "Not-Much Experience in Developing Multi-Platform Projects Using Kotlin KMP, Gaining more Experience in this Field... :)"
    ),
}